<template>
<div class="pimport">
    <multiselect class="pimport__multi" v-model="source_person" 
        label="name"
        track-by="sid"
        placeholder="Введите фамилию туриста или номер заявки"

        :options="found"  
        :multiple="false"
        :searchable="true"
        :loading="isLoading"
        :close-on-select="true"
        :clear-on-select="false"

        :internal-search="false"
        :options-limit="300"
        :show-no-results="true"
        :hide-selected="true"
        @search-change="asyncFind"
        :preserveSearch="true"

        :showNoOptions="false"

        group-values="tourists"
        group-label="name"
        :group-select="false"

        selectLabel="Выбрать"
        selectGroupLabel="Выбрать"
        selectedLabel="Выбрано"
        deselectLabel="Убрать"
        deselectGroupLabel="Убрать"
    >
        <template slot="noResult" slot-scope="{search}">
            <span class="pimport__person error">
                <span v-if="findErr.is">
                    <span v-if="findErr.needAuth">Выполните вход в Кабинет Агента</span>
                    <span v-else>Поиск не выполнен: {{findErr.message}}</span>
                </span>
                <span v-else>"{{search}}" - не найдено</span>
            </span>
        </template>
        <template slot="option" slot-scope="{option,search,index}">
            <span class="pimport__group" v-if="option['$isLabel']">
                <b>{{option.$groupLabel.num}}:</b>
                {{option.$groupLabel.tour}}
                {{dayjs(option.$groupLabel.dateFrom).format('DD.MM.YYYY')}}
                {{option.$groupLabel.town}}
            </span>
            <span v-else class="pimport__person">
                <template v-if="!option.isCust">
                    {{option.lastName}} {{option.firstName}} {{option.middleName}},
                    {{age(option)}}, 
                    <div>{{doc(option)}}</div>
                </template>
                <template v-else>
                    заказчик:
                    {{option.lastName}} {{option.firstName}} {{option.middleName}}
                </template>
            </span>
        </template>
    </multiselect>

    <div class="custom-field">
        <button class="btn btn--blue custom-field__but" :disabled="!source_person" @click="copy_person_do">Внести данные</button>
        <br />Все ранее введенные поля очистятся
    </div>

</div>    
</template>

<style lang="scss" src="./PersonImport.scss"></style>

<script setup>
import {ref, unref, computed} from 'vue'
import useTouristStore from '@/tourist/tourist-store.js'
import {DOC_TYPE_OPTIONS} from '@/tourist/tourist-store.js'
import {touristImport} from '@/actions.js'
import multiselect from 'vue-multiselect'
import dayjs from 'dayjs'
import {translit_and_upper} from '@/tourist/transliterate.js'

const tstore=useTouristStore()

const props = defineProps({
    target : String, // куда его девать
})

const source_person = ref(null)

const found = ref([])
const isLoading = ref(false)
const findErr = ref({ 
    is: false,
    needAuth: false,
    message: '',
})


const asyncFind = (query) => {
    query = query.trim()
    isLoading.value = true
    findErr.value.is = false
    touristImport( {query} ).then( ({claims}) => {
        found.value = found_process( {claims} )
        isLoading.value = false
        return true
    }, (err) => {
        found.value = []
        findErr.value = {
            is: true,
            message: `${err}`,
            needAuth: err.needAuth ? err.needAuth() : false
        }
        isLoading.value = false
    })
    return true
}

const found_process = ({claims}) => {
    return claims.reduce( (all, crec ) => {
        let {claim, tourists, customer} = crec
        let {num} = claim
        let trecs = tourists.map( (tou, tnum) => {
            tou.sid = `${num}.${tnum}`
            tou.name = `→ ${tou.lastName} ${tou.firstName} ${tou.middleName}, ${age(tou)}, ${doc(tou)}`
            tou.isCust = false
            return tou
        }  )
        let name = `✓ ${num}: ${claim.tour} ${dayjs(claim.dateFrom).format('DD.MM.YYYY')} ${claim.town}`
        customer.sid = `${num}.cu`
        customer.name = `→ заказчик: ${customer.lastName} ${customer.firstName} ${customer.middleName}`
        customer.isCust = true
        trecs.push( customer )
        let claimrec = {
            name:claim,
            claim,
            tourists: trecs,
        }
        all.push( claimrec )
        return all
    }, [] )
}

const nowdayjs = dayjs( new Date )
const age = ({born}) => {
    let ret = '?г.'
    if (born) {
        let y = nowdayjs.diff( born, 'year' )
        ret = `${y}г.`
    }
    return ret
}
const doc = ({
        pdocument_type: doc_type,
        pserie: doc_serie,
        pnumber: doc_number,
    }) => {
    let ret = 'документ пуст'
    let opt = DOC_TYPE_OPTIONS.find( ({id})=> id === doc_type  )
    if ( opt && opt.name  ) {
        ret = `${opt.name} ${doc_serie} ${doc_number}`
    }
    return ret
}

const copy_person_do = () => {
    const import_rec = unref(source_person)
    if (import_rec) {
        const vals = choosed_process( import_rec )
        tstore.copy_person( null, props.target, vals )
        source_person.value = null
    }
}

const ymd2dmy = v => v ? dayjs(v).format('DD.MM.YYYY') : ''
const bool2mf = v => v ? 'm' : 'f'
const fill_doc_type = v => {
    let t = ''
    if (['ps', 'svr', 'zps', 'other'].includes(v)) {
        t = v
    } else if (v) {
        t = 'other'
    }
    return t
}
const phone_clean = v => v ?  v.replace(/[^\d+]/g, '') : ''

const choosed_process = tou => {
    let {
        lastName:fname,
        firstName:iname,
        middleName:oname,
        male,
        born,
        country_a2: doc_gra,
        pdocument_type: doc_type,
        pserie: doc_serie,
        pnumber: doc_number,
        pissue: doc_issue,
        pvalid: doc_valid,

        doc_lastName,
        doc_firstName,

        sid, name,

        phone, 
        email, 
        address: doc_address, 
        zip: doc_zip,
        punitcode: doc_unitcode, 
        pauthority: doc_authority, 

        isCust,


    } = tou
    let nov = {
        fname, iname, oname, 
        male: bool2mf(male), 
        born: ymd2dmy(born), 
        doc_gra: doc_gra ? doc_gra : null, // пойдет по умолчанию
        doc_type: fill_doc_type( doc_type ),
        doc_serie, 
        doc_number, 
        doc_issue: ymd2dmy(doc_issue), 
        doc_valid: ymd2dmy(doc_valid),

        phone: phone_clean(phone),
        email,
        doc_address,
        doc_zip,
        doc_unitcode,
        doc_authority,

        sid, name, isCust,
    }

    let add_buttons = unref( tstore.add_buttons )
    nov.tt = add_buttons[0].id

    if (doc_lastName && doc_lastName.match(/[a-z]/i)) {
        nov.flname = doc_lastName 
        nov.ilname = doc_firstName 
    } else {
        nov.flname = translit_and_upper( fname )
        nov.ilname = translit_and_upper( iname )
    }

    return nov
}
</script>
